import BusinessDeleteModal from "./BusinessDeleteModal";

export default BusinessDeleteModal;
